import { call } from "redux-saga/effects";
import { API_URL, sagaFunction, ACTIONS } from "../_config";
import { CallApi } from "./api/callApi";

export function* getCmsContent(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.CMS.GET_CMS, action.payload, true);
}

export function* getPageBySlug(action: any): any {
  const slug = action.payload?.slug || "";
  const url = `${API_URL.CMS.GET_PAGE_BY_SLUG}/${slug}`;
  yield call(sagaFunction, action, CallApi.GET, url, null, true);
}



